export default class VerificadorCaixaAnexo {
    validar(campo, valor) {
        const erros = [];
        if(campo.minimo && valor.length < campo.minimo) {
            erros.push(`É necessário um mínimo de ${campo.minimo} anexo(s)`);
        }

        if(campo.maximo && valor.length > campo.maximo) {
            erros.push(`Só é permitido um máximo de ${campo.maximo} anexo(s)`);
        }
        return erros;
    }
}